<template>
  <div class="zkhd-container">
    <section class="common-section overview-section">
      <section-title :titleInfo="overviewTitle"></section-title>
      <div class="overview-layout">
        <div class="overview-copy">
          <p>
            聚焦“双碳”目标下货运物流绿色转型需求，面向矿山、港口码头、钢厂、电厂及物流园区等固定路线、高强度作业场景，提供电动重卡、智能换电系统、风光储一体化配套及全流程运营管理的一站式解决方案。
          </p>
          <p>
            通过智能换电技术实现分钟级快速补能，缓解重载运输补能效率低、运营成本高等痛点，帮助客户构建安全、高效、低碳的运输补能体系。
          </p>
          <div class="overview-tags">
            <div v-for="item in overviewTags" :key="item.title" class="overview-tag">
              <strong>{{ item.title }}</strong>
              <span>{{ item.text }}</span>
            </div>
          </div>
        </div>
        <img
          class="overview-image"
          src="../images/zkhd/zkhd-overview.jpg"
          alt="重卡换电站鸟瞰图"
        />
      </div>
    </section>

    <section class="common-section advantage-section">
      <section-title :titleInfo="advantageTitle"></section-title>
      <div class="advantage-grid">
        <article v-for="item in advantages" :key="item.title" class="advantage-card">
          <div class="feature-icon">
            <operation-icon :name="item.icon"></operation-icon>
          </div>
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </div>
        </article>
      </div>
    </section>

    <section class="common-section scene-section">
      <section-title :titleInfo="sceneTitle"></section-title>
      <div class="scene-grid">
        <article v-for="item in scenes" :key="item.title" class="scene-card">
          <img :src="item.image" :alt="item.title" />
          <div class="scene-mask">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </div>
        </article>
      </div>
    </section>

    <section class="common-section value-section">
      <section-title :titleInfo="valueTitle"></section-title>
      <div class="value-layout">
        <div class="value-intro">
          <div class="value-kicker">全流程运营管理</div>
          <h3>让换电站、车辆、电池与能源协同运行</h3>
          <p>
            平台统一管理车辆调度、电池状态、换电作业、站内能耗和运维服务，结合风光储资源与电网需求，持续优化换电效率和综合运营成本。
          </p>
        </div>
        <div class="value-grid">
          <article v-for="item in values" :key="item.title" class="value-card">
            <span>{{ item.number }}</span>
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </div>
    </section>

    <section class="contact-banner">
      <div>
        <h2>携手智融科技，共建高效绿色重卡补能生态</h2>
        <p>让每一次出发都更高效、更绿色、更可持续</p>
      </div>
      <a href="tel:02583585700">
        <span>联系我们</span>
        <strong>025-83585700</strong>
      </a>
    </section>
  </div>
</template>

<script>
import SectionTitle from "../../components/section-title.vue";
import OperationIcon from "./operation-icon.vue";

export default {
  name: "CdyyZkhd",
  components: { SectionTitle, OperationIcon },
  data() {
    return {
      overviewTitle: {
        bigtext1: "重卡换电解决方案",
        smallText: "面向高强度运输场景的一站式绿色补能方案",
      },
      advantageTitle: {
        bigtext1: "核心优势",
        smallText: "以快速补能、车电分离和数字化运营提升重卡运输效率",
      },
      sceneTitle: {
        bigtext1: "面向多元运输场景",
        smallText: "覆盖固定路线、高频次与连续作业等典型重载运输需求",
      },
      valueTitle: {
        bigtext1: "方案价值",
        smallText: "从车辆补能延伸至资产、能源与运营的协同优化",
      },
      overviewTags: [
        { title: "3–5分钟", text: "极速换电补能" },
        { title: "车电分离", text: "降低购车门槛" },
        { title: "全维管理", text: "电池与站端统一运维" },
      ],
      advantages: [
        {
          title: "极速效率",
          text: "自动化换电，3–5分钟完成补能，显著提升车辆出勤率。",
          icon: "truck-swap",
        },
        {
          title: "降低门槛",
          text: "采用车电分离模式，降低车辆初始投入与电池资产压力。",
          icon: "charging",
        },
        {
          title: "全维管理",
          text: "统一管理电池健康、换电作业与站端运维，保障安全运营。",
          icon: "data",
        },
        {
          title: "电网友好",
          text: "兼具分布式储能能力，支持削峰填谷与能源协同。",
          icon: "microgrid",
        },
      ],
      scenes: [
        {
          title: "港口码头",
          text: "高频作业，快速补能",
          image: require("../images/zkhd/scene-port.jpg"),
        },
        {
          title: "矿山运输",
          text: "重载运输，强劲可靠",
          image: require("../images/zkhd/scene-mine.jpg"),
        },
        {
          title: "钢厂／电厂",
          text: "固定路线，连续作业",
          image: require("../images/zkhd/scene-industry.jpg"),
        },
        {
          title: "干线物流",
          text: "长途运输，稳定续航",
          image: require("../images/zkhd/scene-logistics.jpg"),
        },
        {
          title: "物流枢纽",
          text: "集中调度，高效周转",
          image: require("../images/zkhd/scene-hub.jpg"),
        },
        {
          title: "高速服务区",
          text: "便捷补能，随行无忧",
          image: require("../images/zkhd/scene-service.jpg"),
        },
      ],
      values: [
        {
          number: "01",
          title: "提效",
          text: "提升车辆补能和周转效率，保障高频运输连续运行。",
        },
        {
          number: "02",
          title: "降本",
          text: "优化车辆、电池与站端资产投入，降低综合运营成本。",
        },
        {
          number: "03",
          title: "环保",
          text: "推动重卡运输链路绿色低碳转型，助力“双碳”目标。",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.zkhd-container {
  width: 100%;
  color: #1d1d1d;
  background: #fff;
}

.common-section {
  box-sizing: border-box;
  padding: 100px clamp(32px, 8.33vw, 160px);
}

.overview-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(420px, 0.9fr);
  gap: 72px;
  align-items: center;
}

.overview-copy {
  p {
    margin: 0 0 18px;
    color: #4e5868;
    font-size: 18px;
    line-height: 2;
  }
}

.overview-tags {
  margin-top: 34px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid #dfe7f2;
}

.overview-tag {
  padding: 24px 18px 4px 0;

  strong,
  span {
    display: block;
  }

  strong {
    margin-bottom: 8px;
    color: #1f63ea;
    font-size: 24px;
  }

  span {
    color: #7d8797;
    font-size: 14px;
  }
}

.overview-image {
  width: 100%;
  height: 430px;
  object-fit: cover;
  border-radius: 2px;
  box-shadow: 0 18px 44px rgba(24, 57, 108, 0.14);
}

.advantage-section,
.value-section {
  background: #f6f8fc;
}

.advantage-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
}

.advantage-card {
  min-height: 205px;
  box-sizing: border-box;
  padding: 34px 28px;
  display: flex;
  gap: 22px;
  border: 1px solid #e2e9f3;
  background: #fff;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 36px rgba(31, 99, 234, 0.1);
  }

  h3 {
    margin: 3px 0 14px;
    font-size: 22px;
    font-weight: 500;
  }

  p {
    margin: 0;
    color: #7d8797;
    font-size: 15px;
    line-height: 1.8;
  }
}

.feature-icon {
  width: 54px;
  height: 54px;
  flex: none;
  box-sizing: border-box;
  padding: 10px;
  color: #1f63ea;
  border: 1px solid #cfe0ff;
  background: #f1f6ff;
}

.scene-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.scene-card {
  height: 270px;
  position: relative;
  overflow: hidden;
  background: #dfe6ef;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    transition: transform 0.5s;
  }

  &:hover img {
    transform: scale(1.035);
  }
}

.scene-mask {
  box-sizing: border-box;
  padding: 48px 24px 22px;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  color: #fff;
  background: linear-gradient(transparent, rgba(4, 29, 65, 0.88));

  h3 {
    margin: 0 0 8px;
    font-size: 22px;
    font-weight: 500;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: 14px;
  }
}

.value-layout {
  display: grid;
  grid-template-columns: 0.8fr 1.5fr;
  gap: 70px;
  align-items: stretch;
}

.value-intro {
  box-sizing: border-box;
  padding: 42px;
  color: #fff;
  background: linear-gradient(145deg, #124bba, #2f75f2);

  .value-kicker {
    margin-bottom: 24px;
    color: #bcd5ff;
    font-size: 15px;
    letter-spacing: 2px;
  }

  h3 {
    margin: 0 0 24px;
    font-size: 30px;
    font-weight: 500;
    line-height: 1.5;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: 16px;
    line-height: 2;
  }
}

.value-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.value-card {
  box-sizing: border-box;
  padding: 36px 28px;
  border: 1px solid #e2e9f3;
  background: #fff;

  span {
    display: block;
    margin-bottom: 38px;
    color: #abc7f9;
    font-size: 36px;
  }

  h3 {
    margin: 0 0 16px;
    color: #1f63ea;
    font-size: 25px;
    font-weight: 500;
  }

  p {
    margin: 0;
    color: #687486;
    font-size: 15px;
    line-height: 1.8;
  }
}

.contact-banner {
  min-height: 190px;
  box-sizing: border-box;
  padding: 42px clamp(32px, 8.33vw, 160px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  background:
    linear-gradient(90deg, rgba(11, 68, 180, 0.98), rgba(38, 111, 239, 0.9)),
    url("../images/zkhd/scene-logistics.jpg") center 48% / cover;

  h2 {
    margin: 0 0 12px;
    font-size: 30px;
    font-weight: 500;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.75);
    font-size: 16px;
  }

  a {
    min-width: 220px;
    box-sizing: border-box;
    padding: 18px 28px;
    color: #1f63ea;
    text-decoration: none;
    background: #fff;

    span,
    strong {
      display: block;
    }

    span {
      margin-bottom: 6px;
      color: #7d8797;
      font-size: 13px;
    }

    strong {
      font-size: 21px;
      font-weight: 500;
    }
  }
}

@media (max-width: 1200px) {
  .overview-layout,
  .value-layout {
    gap: 38px;
  }

  .advantage-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 900px) {
  .common-section {
    padding: 70px 28px;
  }

  .overview-layout,
  .value-layout {
    grid-template-columns: 1fr;
  }

  .overview-image {
    height: 360px;
  }

  .scene-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .value-grid {
    grid-template-columns: repeat(3, minmax(190px, 1fr));
    overflow-x: auto;
  }

  .contact-banner {
    gap: 30px;
  }
}

@media (max-width: 640px) {
  .overview-tags,
  .advantage-grid,
  .scene-grid {
    grid-template-columns: 1fr;
  }

  .overview-image {
    height: 270px;
  }

  .contact-banner {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
